export default function Logo({ size = 40 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
      <polygon
        points="22,3 41,13 41,31 22,41 3,31 3,13"
        fill="#3B82F6"
        stroke="#2D3F5E"
        strokeWidth="1.5"
      />
      <text
        x="22" y="27"
        textAnchor="middle"
        fill="#0F172A"
        fontSize="14"
        fontWeight="800"
        fontFamily="Manrope, sans-serif"
        letterSpacing="-0.5"
      >MT</text>
    </svg>
  );
}
